var _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgControlGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10H9.5C8.65625 10 8 10.6875 8 11.5V20.5C8 21.3438 8.65625 22 9.5 22H22.5C23.3125 22 24 21.3438 24 20.5V11.5C24 10.6875 23.3125 10 22.5 10ZM22.5 11.5V12.7812C21.7812 13.375 20.6562 14.25 18.2812 16.125C17.75 16.5312 16.7188 17.5312 16 17.5C15.25 17.5312 14.2188 16.5312 13.6875 16.125C11.3125 14.25 10.1875 13.375 9.5 12.7812V11.5H22.5ZM9.5 20.5V14.7188C10.1875 15.2812 11.2188 16.0938 12.75 17.3125C13.4375 17.8438 14.6562 19.0312 16 19C17.3125 19.0312 18.5 17.8438 19.2188 17.3125C20.75 16.0938 21.7812 15.2812 22.5 14.7188V20.5H9.5Z",
    fill: "#36424E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5938 25.3828C27.8281 25.6172 28.2188 25.5391 28.4531 25.2656L28.8438 24.7969C29.0781 24.5234 29 24.1328 28.7656 23.9375L5.40625 5.65625C5.13281 5.42188 4.74219 5.5 4.50781 5.73438L4.11719 6.24219C3.88281 6.51562 3.96094 6.90625 4.23438 7.10156L27.5938 25.3828Z",
    fill: "#36424E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#36424E",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgControlGroup);
export default __webpack_public_path__ + "static/media/img_control_group.dafc833b872c049fd62a83d3b2ba1bfb.svg";
export { ForwardRef as ReactComponent };